import { ChatbotMessages } from "@core/domain/models/chatbot-message.model";
import type { ChatbotRepository } from "@core/domain/repositories/chatbot.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import { coreTypes } from "@core/root/core-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class ChatbotSendMessageUseCase {
    constructor(
        @inject(coreTypes.repositories.ChatbotRepository)
        private readonly chatbotRepository: ChatbotRepository,
    ) {}
    async execute(message: string): Promise<ChatbotMessages> {
        const messageResult = await this.chatbotRepository.sendMessage(message);

        return messageResult.match(
            (chatbotMessages) => chatbotMessages,
            (error) => {
                ToastManagerRepository.error(error.message);
                return ChatbotMessages.empty();
            },
        );
    }
}
